@use 'src/global/variables.scss' as var;

leichte-sprache-user-avatar {
  border-radius: 100vh;
  box-shadow: var.$message-screen-elements-box-shadow;
  background: var.$ls-user-bubble;
  svg {
    width: 3.4rem;
    height: 3.4rem;
  }
}
